import { Box } from "@chakra-ui/react"
import { AlgoliaIndexes, DomainObjects } from "projectlink-common"
import PageHeading from "src/common/PageHeading"
import FilterableSearchInput from "src/search/FilterableSearchInput"
import Hits from "src/search/Hits"
import SearchableFeedProvider from "src/search/SearchableFeedProvider"
import { domainColor } from "src/util/style"

function Organizations({ initialTopics, initialHits }) {
  return (
    <SearchableFeedProvider
      indexName={AlgoliaIndexes.organizations}
      initialHits={initialHits}
    >
      <Box layerStyle='appContainer'>
        <PageHeading
          maxW='container.md'
          mx='auto'
          my='base'
          color={domainColor(DomainObjects.organization)}
        >
          Companies
        </PageHeading>
        <FilterableSearchInput
          initialTopics={initialTopics}
          hideTypes={true}
          mb='base'
        />
        <Hits />
      </Box>
    </SearchableFeedProvider>
  )
}

export default Organizations